import { Phone, Mail, ShieldCheck, MapPin, ArrowUpRight } from "lucide-react";
import { STUDIO } from "@/content";
import { SITE } from "@/constants/testIds";
import { Reveal, SectionHead } from "./Reveal";
import { WhatsappIcon } from "./WhatsappIcon";

const ITEMS = [
  { id: SITE.contactPhone, icon: Phone, label: "Telefono", value: STUDIO.phoneLabel, href: STUDIO.phoneHref },
  { id: SITE.contactWhatsapp, icon: WhatsappIcon, label: "WhatsApp", value: "Scrivi un messaggio", href: STUDIO.whatsappHref, ext: true },
  { id: SITE.contactEmail, icon: Mail, label: "Email", value: STUDIO.email, href: `mailto:${STUDIO.email}` },
  { id: SITE.contactPec, icon: ShieldCheck, label: "PEC", value: STUDIO.pec, href: `mailto:${STUDIO.pec}` },
];

export const Contacts = () => (
  <section id="contatti" className="section-pad bg-white">
    <div className="container-x">
      <SectionHead index="06" eyebrow="Contatti" title="Passa in studio, oppure scrivici." />
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 flex flex-col">
          <Reveal data-testid={SITE.contactAddress} className="flex gap-4 pb-8 border-b border-navy-100">
            <MapPin className="h-6 w-6 text-bronze shrink-0" strokeWidth={1.5} />
            <div>
              <p className="text-xs uppercase tracking-[0.24em] text-navy-500">Indirizzo</p>
              <p className="mt-2 text-lg font-semibold text-navy-900">{STUDIO.address}</p>
              <p className="text-navy-900">{STUDIO.city}</p>
            </div>
          </Reveal>
          {ITEMS.map((it, i) => (
            <Reveal key={it.id} delay={i * 60}>
              <a
                href={it.href}
                data-testid={it.id}
                {...(it.ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="group flex items-center gap-4 py-6 border-b border-navy-100 hover:pl-2 transition-[padding] duration-300"
              >
                <it.icon className="h-5 w-5 text-bronze shrink-0" />
                <span className="flex-1 min-w-0">
                  <span className="block text-xs uppercase tracking-[0.24em] text-navy-500">{it.label}</span>
                  <span className="block mt-1 font-semibold text-navy-900 break-all">{it.value}</span>
                </span>
                <ArrowUpRight className="h-5 w-5 text-navy-200 transition-colors group-hover:text-navy-900" />
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal className="lg:col-span-7 min-h-[380px]" delay={150}>
          <iframe
            data-testid={SITE.contactMap}
            title="Mappa Studio Legale D'Arienzo"
            src={`https://maps.google.com/maps?q=${encodeURIComponent(STUDIO.mapQuery)}&z=16&output=embed`}
            className="h-full w-full min-h-[380px] rounded-3xl border border-navy-100 grayscale-[35%]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Reveal>
      </div>
    </div>
  </section>
);
